<script setup lang="ts">
const envName = ENV.EnvironmentName.toLowerCase()
const ribbonText = envName.charAt(0).toUpperCase() + envName.slice(1)

const envColors = {
  local: '#D32F2F',
  dev: '#FF8C00',
  staging: '#8A2BE2',
}

const backgroundColor = envColors[envName]
</script>

<template>
  <div
    class="env-ribbon"
    :style="backgroundColor ? { backgroundColor } : {}"
  >
    {{ribbonText}}
  </div>
</template>

<style scoped lang="scss">
  @use '../../../styles/variables' as variables;

  .env-ribbon {
    position: fixed;
    @include variables.zIndex(envRibbon);
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background: map-get(variables.$colors, container-highest);
    color: white;
    padding: map-get(variables.$spacing, space-0-5) map-get(variables.$spacing, space-2);
    padding-top: variables.$safeAreaTop;
    font-weight: 700;
    font-size: map-get(variables.$textSizes, text-sm);
    border-radius: variables.$borderRadius;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    pointer-events: none;
  }
</style>
